import { render } from "./RightArrow.vue?vue&type=template&id=aa6a7d5e"
import script from "./RightArrow.vue?vue&type=script&lang=js"
export * from "./RightArrow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/coastal-watchers-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__